import '../../assets/css/style1.css';
import { Link } from 'react-router-dom';
import { Form, Input, Button, message } from 'antd';
import React, {  useState } from 'react';
import api from '../../services/api';
import Socialicon from '../../pages/PrivacyPolicy/Socialicon';
const Footer = () => {

    const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
    const onFinish = async (values) => {
    try {
      setLoading(true);
      const response = await api.post('/subscribe', values);
      if (response.data.success) {
        message.success('Thank you for subscribing!');
        form.resetFields();
      } else {
        message.error(response.data.message || 'Subscription failed');
      }
    } catch (error) {
      message.error(error.response?.data?.message || 'Subscription failed');
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <footer className="footer5 footer--bw">
        <div className="footer__big">
          <div className="container">
            <div className="row">
              {/* Logo and About */}
              <div className="col-lg-3 col-md-6 col-sm-6">
                <div className="widget text_widget">
                  <img
                    className="footer_logo"
                    src="https://snmtechnologies.in/startup/img/startupbusiness-white.png"
                    alt="logo"
                  />
                  <p>
                  Startup Business Partner’s vision is to transform your dreams into reality. We stand with you in building a better life, a stronger future, and lasting success for generations to come. Give your life a new direction today and move forward with confidence.
                  </p>
                 
                </div>
              </div>

              {/* Quick Links */}
              <div className="col-lg-3 col-md-6 col-sm-6 d-flex justify-content-lg-center">
                <div className="widget widget--links">
                  <h4 className="widget__title">Quick Links</h4>
                  <ul className="links">
        <li className="nav-item active">
      <Link className="nav-link" to="/">Home</Link>
    </li>
    <li className="nav-item active">
      <Link className="nav-link" to="/about">About us</Link>
    </li>
    <li className="nav-item active">
      <Link className="nav-link" to="/plan">Plan</Link>
    </li>

    <li className="nav-item active">
      <Link className="nav-link" to="/video">Video</Link>
    </li>
    <li className="nav-item active">
      <Link className="nav-link" to="/blog">Blog</Link>
    </li>
  
    <li className="nav-item active">
      <Link className="nav-link" to="/contact">Contact</Link>
    </li>
                  </ul>
                </div>
              </div>

              {/* Our Services */}
              <div className="col-lg-3 col-md-6 col-sm-6 d-flex justify-content-lg-center">
                <div className="widget widget--links">
                  <h4 className="widget__title">More Links</h4>
                  <ul className="links">
         {/* <li className="nav-item active">
      <Link className="nav-link" to="/career">Careers</Link>
    </li> */}
       <li className="nav-item active">
      <Link className="nav-link" to="/privacypolicy">Privacy Policy</Link>
    </li>
    <li className="nav-item active">
      <Link className="nav-link" to="/teammember">Our Team</Link>
    </li>
    <li className="nav-item active">
      <Link className="nav-link" to="/termscondition">Terms and Condition</Link>
    </li>
        <li className="nav-item active">
      <Link className="nav-link" to="/refundpolicy">Refund Policy</Link>
    </li>
    <li className="nav-item active">
      <Link className="nav-link" to="/faq">FAQ</Link>
    </li>

                  </ul>
                </div>
              </div>

              {/* Newsletter and Social */}
              <div className="col-lg-3 col-md-6 col-sm-6">
                <div className="widget subcribe--widget">
                  <h4 className="widget__title">Newsletter</h4>
                  <p>
                    Subscribe to get update and information. Don't worry, we
                    won't send spam!
                  </p>
               <Form form={form} onFinish={onFinish} className="subscribe-form-two">
              <div>
                <Form.Item
                  name="email"
                  rules={[
                    { required: true, message: 'Please input your email!' },
                    { type: 'email', message: 'Please enter a valid email!' }
                  ]}
                >
                  <Input 
                    placeholder="Enter your email address" 
                    aria-label="Email"
                    className="form-control"
                  />
                </Form.Item>
                <Button 
                  htmlType="submit" 
                  style={{padding:'0px 18px 10px 18px'}}
                  className="btn btn-primary"
                  loading={loading}
                >
                  Subscribe Now
                </Button>
              </div>
            </Form>

                  <div className="widget__social">
                    <div className="social">
               <Socialicon />
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        <div className="footer__small text-center">
          <p>
            ©2025 Startup Business. All rights reserved. <a href="#"></a>
          </p>
        </div>

<a
  href="https://wa.me/918860003484" // Replace with your actual number
  target="_blank"
  rel="noopener noreferrer"
  style={{
    position: 'fixed',
    bottom: '20px',
    left: '20px',
    zIndex: 9999,
    borderRadius: '50%',
    padding: '5px',
    backgroundColor: 'transparent',
    transition: 'transform 0.3s ease-in-out',
  }}
  onMouseEnter={e => (e.currentTarget.style.transform = 'scale(1.1)')}
  onMouseLeave={e => (e.currentTarget.style.transform = 'scale(1)')}
>
  <img
    src="https://img.icons8.com/color/48/000000/whatsapp--v1.png"
    alt="WhatsApp"
    style={{ width: '50px', height: '50px' }}
  />
</a>

      </footer>

      <div className="go_top">
        <span className="la la-angle-up"></span>
      </div>
    </>
  );
};

export default Footer;
